module.exports = __webpack_public_path__ + "img/green_126.16635bcc.png";